/**
 * Token + current-user storage for the DM SPA. Backed by localStorage so a
 * page refresh keeps the session until the access token expires (then the
 * dmClient refresh interceptor silently renews it via the refresh token).
 */
const ACCESS_KEY = 'dm_token';
const REFRESH_KEY = 'dm_refresh';
const USER_KEY = 'dm_user';

export const tokenStore = {
  getAccess: () => localStorage.getItem(ACCESS_KEY) || '',
  getRefresh: () => localStorage.getItem(REFRESH_KEY) || '',
  getUser: () => {
    try {
      const raw = localStorage.getItem(USER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_e) {
      return null;
    }
  },
  setSession: ({ token, refreshToken, user }) => {
    if (token) localStorage.setItem(ACCESS_KEY, token);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  setTokens: ({ token, refreshToken }) => {
    if (token) localStorage.setItem(ACCESS_KEY, token);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  },
  setUser: (user) => {
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
  },
  isAuthenticated: () => !!localStorage.getItem(ACCESS_KEY),
};

export default tokenStore;
